import * as React from "react";
import { useContext } from "react";
const IndexRetentionContext = React.createContext(null);
const useIndexRetention = () => {
  try {
    const context = useContext(IndexRetentionContext);
    if (!context) {
      throw new Error("useIndexRetention must be used within a IndexRetentionProvider");
    }
    return context;
  } catch {
    return { useMaxNumberOfIndices: [9999, () => {
    }] };
  }
};
export { useIndexRetention };
export default IndexRetentionContext;
